module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0066.jpg?v=2d57ed17";